// @ts-strict-ignore
import clsx from 'clsx'
import React, { memo, useRef } from 'react'
import { useSelector } from 'react-redux'

import { useProductBonus } from '@/screens/Product/hooks/useProductBonus'

import { useCheckAuth } from '@/features/auth/check'

import { isAuthorizationInited } from '@/entities/user'

import { DiscountList } from '../../../discount-list/discount-list'
import { MindBoxBannerContainer } from '../../../mind-box-banner-container/MindBoxBannerContainer'

import { BonusBar } from './BonusBar/BonusBar'
import { PricesBlock } from './PricesBlock/PricesBlock'

import cl from './product-price-widget.module.scss'

interface ProductPriceWidgetProps {
	className?: string
	productId: number
	price: number
	oldPrice?: number
	isBot?: boolean
	productIsInStock?: boolean
}

export const ProductPriceWidget = memo((props: ProductPriceWidgetProps) => {
	const { className, price, oldPrice, productId, isBot, productIsInStock } = props

	// Additional state for setting price loader when user authorized
	// and refetching new personal price
	const specialState = useRef(false)

	const isAuthInited = useSelector(isAuthorizationInited)
	const { isAuthorized } = useCheckAuth()

	const { isLoading, isFetching, isError, discountPrice, bonusAccrued, discountList, discountProfit } = useProductBonus(
		productId,
		!price || !productIsInStock
	)

	const loadingCondition_1 = isAuthorized && isLoading
	const loadingCondition_2 = isAuthorized && isFetching && specialState.current

	const pricesBlockLoadingState = isAuthInited ? loadingCondition_1 || loadingCondition_2 : false

	return (
		<div className={clsx(cl.root, className)}>
			<div className={cl.main}>
				<PricesBlock
					discountedPrice={discountPrice}
					currentPrice={price}
					oldPrice={oldPrice}
					isLoading={isBot ? false : pricesBlockLoadingState}
				/>
				{!!discountProfit && (
					<DiscountList className={cl.discount} price={discountProfit} items={discountList} defaultOpen />
				)}
				<BonusBar productId={productId} bonuses={bonusAccrued} isLoading={isFetching} isError={isError} />
				<MindBoxBannerContainer />
			</div>
		</div>
	)
})
